import "./PhishingPrevention.module.css";
import Header from "@/reusable_sections/Header";
import SecurityHero from "./sections/SecurityHero";
import Servicedetail from "./sections/Servicedetail";
import Footer from "@/reusable_sections/Footer";
export default function PhishingPreventionPage() {
  return <div>
      <Header />
      <SecurityHero />
      <Servicedetail />
      <Footer />
    </div>;
}